import { useToast } from "primevue/usetoast";

const getToastUtil = (severity, toast) => {
  return (detail, summary = undefined, life = 4000, group = undefined, config = {}) => {
    summary = (() => {
      if (summary) return summary;
      else if (severity === "warn") return "Warning";
      else return severity[0].toUpperCase() + severity.slice(1);
    })();

    toast.add({ severity, detail, summary, life, group, ...config });
  }
}

export function useToastUtil() {
  const toast = useToast();

  return {
    info: getToastUtil('info', toast),
    error: getToastUtil('error', toast),
    success: getToastUtil('success', toast),
    warn: getToastUtil('warn', toast),
    clearAll: () => toast.removeAllGroups()
  }
}